export default (value) => {
    if (value) {
        return value.toString().toLowerCase();
    }

    return '';
}